import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import "../css/header.css";

const navItems = [
    { label: 'Home', to: '/' },
    { label: 'Who we are', to: '/about-us' },
    {
        label: 'Services', to: '/services', children: [
            { label: 'AI Agents', to: '/services#aiagent' },
            { label: 'Web Development', to: '/services#webdev' },
        ]
    },
    {
        label: 'Products', to: '/products', children: [
            { label: 'Comment IQ', to: '/products#commentIQ' },
            { label: 'ReconIQ', to: '/products#reconIQ' },
        ]
    },
    {
        label: 'Opportunities', to: '/opportunities', children: [
            { label: 'AI/ML Internship', to: '/opportunities#ai' },
            { label: 'Full Stack Internship', to: '/opportunities#fullstack' },
        ]
    },
];

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => setIsScrolled(window.scrollY > 10);
        handleScroll();
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // Close the mobile menu whenever the route or hash changes.
    useEffect(() => {
        setIsOpen(false);
    }, [location.pathname, location.hash]);

    const handleNavigation = (path) => {
        setIsOpen(false);
        if (location.pathname === path) {
            window.scrollTo(0, 0);
        }
        // Let hover dropdowns close after a click.
        if (document.activeElement) document.activeElement.blur();
    };

    return (
        <nav className={`navbar ${isScrolled ? "scrolled" : ""} ${isOpen ? "menu-open" : ""}`}>
            <div className="container">
                <Link to="/" className="logo" onClick={() => handleNavigation("/")}>
                    <img
                        src={`${process.env.PUBLIC_URL}/images/logo.png`}
                        alt="Manvidia — Innovation Matters"
                        className="logo-img"
                    />
                </Link>

                <button
                    className="navbar-toggler"
                    onClick={() => setIsOpen(!isOpen)}
                    aria-label={isOpen ? "Close menu" : "Open menu"}
                    aria-expanded={isOpen}
                >
                    <span className="toggler-bar"></span>
                    <span className="toggler-bar"></span>
                    <span className="toggler-bar"></span>
                </button>

                <div className={`navbar-menu ${isOpen ? "open" : ""}`}>
                    <ul className="navbar-nav">
                        {navItems.map(item => (
                            <li className={`nav-item ${item.children ? "has-dropdown" : ""}`} key={item.to}>
                                <NavLink
                                    className="nav-link"
                                    to={item.to}
                                    end={item.to === '/'}
                                    onClick={() => handleNavigation(item.to)}
                                >
                                    {item.label}
                                    {item.children && <i className="fas fa-chevron-down" aria-hidden="true"></i>}
                                </NavLink>
                                {item.children && (
                                    <div className="dropdown">
                                        {item.children.map(child => (
                                            <HashLink
                                                className="dropdown-item"
                                                smooth
                                                to={child.to}
                                                key={child.to}
                                                onClick={() => handleNavigation(child.to)}
                                            >
                                                {child.label}
                                            </HashLink>
                                        ))}
                                    </div>
                                )}
                            </li>
                        ))}
                        <li className="nav-item nav-cta">
                            <Link className="btn" to="/contact-us" onClick={() => handleNavigation("/contact-us")}>
                                Contact Us
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Header;
